module.exports = __webpack_public_path__ + "static/media/rest-bg.3046919e.jpg";